// src/utils/formatMoney.js
// Currency-aware money formatter for the Command Center (FR-025: currency is
// scoped by the API, never hard-coded to '$'). Do NOT reuse formatNumber.js:fCurrency
// which hard-codes the dollar sign. Precedent: syndication/AdminAnalytics.js:27-35.
export default function formatMoney(value, currencyCode) {
  if (value === null || value === undefined) return '—';
  return new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: currencyCode || 'USD',
    maximumFractionDigits: 0,
  }).format(Number(value || 0));
}
